<template>
    <app-dialog
        :value="hasPendingLegalDocuments"
        persistent
        hide-close
        size="md"
    >
        <template #header>
            <h2 class="text-xl font-semibold text-theme-base">
                Antes de seguir, revisa y acepta estos documentos
            </h2>
        </template>
        <legal-consent-checkboxes
            v-model="consentsAccepted"
            :documents="pendingLegalDocuments"
            class="mt-2"
        />
        <template #footer>
            <div class="flex flex-col items-center gap-3">
                <app-button
                    color="brand-blue"
                    block
                    :disabled="!consentsAccepted"
                    @click="accept"
                >
                    Acepto
                </app-button>
                <button
                    type="button"
                    class="text-sm text-theme-muted underline"
                    @click="signOut"
                >
                    Cerrar sesión
                </button>
            </div>
        </template>
    </app-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import { toAcceptancePayload } from "@/common/fields/legal-documents";

import LegalConsentCheckboxes from "@/components/legal/LegalConsentCheckboxes.vue";
import AppButton from "@/components/utils/AppButton.vue";
import AppDialog from "@/components/utils/AppDialog.vue";

export default {
    name: "LegalAcceptanceModal",
    components: { AppButton, AppDialog, LegalConsentCheckboxes },
    data: () => ({
        consentsAccepted: false
    }),
    computed: {
        ...mapState("auth", ["pendingLegalDocuments"]),
        ...mapGetters("auth", ["hasPendingLegalDocuments"]),
        ...mapGetters("control", ["backgroundColor"])
    },
    methods: {
        ...mapActions("legal", [
            "acceptLegalDocuments",
            "loadPendingLegalDocuments"
        ]),
        ...mapActions("auth", ["signOut"]),
        async accept() {
            if (!this.consentsAccepted) return;
            try {
                await this.$loading.wrap(() =>
                    this.acceptLegalDocuments({
                        documents: toAcceptancePayload(
                            this.pendingLegalDocuments
                        )
                    })
                );
                this.consentsAccepted = false;
            } catch (error) {
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
                if (error.statusCode === 400) {
                    this.loadPendingLegalDocuments().catch(() => {});
                }
            }
        }
    }
};
</script>
